<div class="container-fluid content-padded small-content">
  <div class="row justify-content-center">
    <div class="col-md-12">
      <div class="error content-padded" *ngIf="!notFound; else notFoundTemplate">
        <h1 class="title">
          Sorry for inconvenience, please try again later.
        </h1>
        <button class="btn btn-large btn-csc-primary" [routerLink]="['/login']">Go back to front page</button>
      </div>
      <ng-template #notFoundTemplate>
        Oops :( Not found
      </ng-template>
    </div>
  </div>
</div>
